import { render, staticRenderFns } from "./VerticalTab.vue?vue&type=template&id=b8e812a8&scoped=true"
import script from "./VerticalTab.vue?vue&type=script&lang=js"
export * from "./VerticalTab.vue?vue&type=script&lang=js"
import style0 from "./VerticalTab.vue?vue&type=style&index=0&id=b8e812a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e812a8",
  null
  
)

export default component.exports